var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreasedLdl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20.819996",
    id: "svg71",
    width: 20,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .ldl-cls-1 {\n        fill: #fff;\n      }\n\n      .ldl-cls-1, .ldl-cls-2, .ldl-cls-3, .ldl-cls-4 {\n        stroke: #000;\n        stroke-linejoin: round;\n      }\n\n      .ldl-cls-1, .ldl-cls-2, .ldl-cls-4 {\n        stroke-linecap: round;\n      }\n\n      .ldl-cls-1, .ldl-cls-4 {\n        stroke-width: 1.5px;\n      }\n\n      .ldl-cls-5 {\n        clip-path: url(#clippath-6);\n      }\n\n      .ldl-cls-6 {\n        clip-path: url(#clippath-7);\n      }\n\n      .ldl-cls-7 {\n        clip-path: url(#clippath-4);\n      }\n\n      .ldl-cls-8, .ldl-cls-2, .ldl-cls-3, .ldl-cls-4 {\n        fill: none;\n      }\n\n      .ldl-cls-9 {\n        clip-path: url(#clippath-1);\n      }\n\n      .ldl-cls-10 {\n        clip-path: url(#clippath-5);\n      }\n\n      .ldl-cls-11 {\n        clip-path: url(#clippath-3);\n      }\n\n      .ldl-cls-12 {\n        clip-path: url(#clippath-2);\n      }\n\n      .ldl-cls-13 {\n        clip-path: url(#clippath);\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g71",
    transform: "translate(-85.540001,-107.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ldl-cls-4",
    d: "m 92.66,122.77 c -1.7,-0.99 -2.85,-2.84 -2.85,-4.95 0,-3.17 2.57,-5.73 5.73,-5.73 3.16,0 5.73,2.57 5.73,5.73 0,2.12 -1.15,3.96 -2.85,4.95 h 4.77 c 0.93,-1.43 1.47,-3.12 1.47,-4.95 0,-5.04 -4.08,-9.12 -9.12,-9.12 -5.04,0 -9.12,4.08 -9.12,9.12 0,1.83 0.54,3.53 1.47,4.95 z",
    id: "path45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g51"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ldl-cls-4",
    x1: 91.75,
    y1: 121.68,
    x2: 92.779999,
    y2: 120.65,
    id: "line45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ldl-cls-4",
    x1: 90.18,
    y1: 117.89,
    x2: 91.639999,
    y2: 117.89,
    id: "line46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ldl-cls-4",
    x1: 91.75,
    y1: 114.1,
    x2: 92.779999,
    y2: 115.13,
    id: "line47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ldl-cls-4",
    x1: 95.540001,
    y1: 112.53,
    x2: 95.540001,
    y2: 113.99,
    id: "line48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ldl-cls-4",
    x1: 99.330002,
    y1: 114.1,
    x2: 98.300003,
    y2: 115.13,
    id: "line49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ldl-cls-4",
    x1: 100.9,
    y1: 117.89,
    x2: 99.440002,
    y2: 117.89,
    id: "line50"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ldl-cls-4",
    x1: 99.330002,
    y1: 121.68,
    x2: 98.300003,
    y2: 120.65,
    id: "line51"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "ldl-cls-4",
    cx: 95.540001,
    cy: 117.84,
    r: 0.36000001,
    id: "circle51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ldl-cls-4",
    x1: 98.18,
    y1: 118.99,
    x2: 95.540001,
    y2: 117.89,
    id: "line52"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "ldl-cls-4",
    x: 86.290001,
    y: 122.77,
    width: 18.5,
    height: 5.25,
    id: "rect52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ldl-cls-2",
    d: "m 95.01,124.34 v 2.1 c 0,0 1.87,0.4 1.68,-1.21 -0.14,-1.19 -1.68,-0.9 -1.68,-0.9 z",
    id: "path52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g54"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ldl-cls-2",
    x1: 98.400002,
    y1: 124.34,
    x2: 98.400002,
    y2: 126.44,
    id: "line53"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ldl-cls-2",
    x1: 99.839996,
    y1: 126.44,
    x2: 98.400002,
    y2: 126.44,
    id: "line54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ldl-cls-2",
    x1: 91.949997,
    y1: 124.34,
    x2: 91.949997,
    y2: 126.44,
    id: "line55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ldl-cls-2",
    x1: 93.389999,
    y1: 126.44,
    x2: 91.949997,
    y2: 126.44,
    id: "line56"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreasedLdl);
export default __webpack_public_path__ + "static/media/IncreasedLDL.067b219a41a12cc66a646520a5e39ac3.svg";
export { ForwardRef as ReactComponent };